import React from "react";
import './CompanyProfile.css';
import building from "./assets/ComBuild.png";
import company from "./assets/company-profile.jpeg";
import Official from "./assets/Official.jpeg";
import office from "./assets/team.png";
import globe from "./assets/companyGlobe.png";
import inspection from "./assets/inspection.png";
// import HomeLeft from "../Components/HomeLeft";
// import HomeRight from "../Components/HomeRight";
import vision from "./assets/vision.png";
import mission from "./assets/mission.png";
import values from "./assets/Values.png";


const CompanyProfile = () => {
    return (
        <>
        <div className="container">
            <div className="row">
            {/* Middle Column */}
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="row combanner">
                        <h2>Company Profile</h2>
                        <div className="col-lg-12">
                            <img src={company} alt="Saad Motors" className="mainprofile img-fluid" />
                        </div>
                        <div className="col-lg-12 mt-3 maincolprofile">
                            <p>SAAD MOTORS (THAILAND) CO.,LTD is a Thailand-based exporter specializing in high-quality used vehicles, commercial trucks, buses, and heavy machinery. We are committed to supplying reliable vehicles to customers worldwide through transparent business practices, competitive pricing, and professional customer service. Our goal is to build long-term relationships by delivering quality, trust, and customer satisfaction in every shipment.                             
                            </p>
                        </div>
                    </div>

                    <div className="row comrow combanner">
                        <div className="col-lg-4 col-md-12">
                            <img src={Official} alt="SAAD MOTORS" className="miteam img-fluid" />
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <p>SAAD MOTORS provides direct access to a wide network of used vehicle suppliers and trusted sources across Thailand.
                            We carefully compare available vehicles, prices, specifications, and conditions from multiple sources to secure competitive market prices for our customers.
                            Our strong supplier network and market experience allow us to offer quality vehicles at the best possible prices, with transparent and reliable service from sourcing to export.</p>
                        </div>
                    </div>

                    {/* <div className="row comrow combanner">                        
                        <div className="col-lg-8 col-md-12">
                            <p>Our corporate strength comes from providing to the demands of a global market with services
                                ranging from sales, transport, reliable remittance procedures and delivery to local customers.
                                We furthermore expanding our Business providing Vehicles from Thailand, Dubai & Singapore.</p>
                        </div>
                        <div className="col-lg-4 col-md-12">
                            <img src={globe} alt="SAAD MOTORS" className="miteam img-fluid" />
                        </div>
                    </div> */}

                    <div className="row comrow combanner">
                        <div className="col-lg-4 col-md-12">
                            <img src={inspection} alt="SAAD MOTORS" className="miteam img-fluid" />
                        </div>
                        <div className="col-lg-8 col-md-12">
                            <p>
                                "Our headquarters are based in THAILAND, where all our core operations are carried out. Our
                                dedicated sales office is located in Pakistan, managing all sales transactions, invoicing, and
                                auctions to ensure seamless service delivery."</p>
                        </div>
                    </div>

                    <div className="col-lg-12 comtable py-5">
                        <h2>CORPORATE DETAILS:</h2>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">COMPANY NAME</th>
                                    <td scope="col">SAAD MOTORS (THAILAND) CO.,LTD</td>
                                </tr>
                            </thead>
                            <tbody>
                                {/* <tr>
                                    <th scope="row">PRESIDENT & CEO</th>
                                    <td>MUHAMMAD RAFIQ</td>
                                </tr> */}
                                <tr>
                                    <th scope="row">ADDRESS</th>
                                    <td>127/2 Kaha Romklao Road, Rat Phatthana Subdistrict, Saphan Sung District, Bangkok 10240, Thailand</td>
                                </tr>
                                <tr>
                                    <th scope="row">POSTAL CODE</th>
                                    <td>10240</td>
                                </tr>
                                {/* <tr>
                                    <th scope="row">PHONE</th>
                                    <td>+81 90-5342-1744</td>
                                </tr>
                                <tr>
                                    <th scope="row">WHATSAPP</th>
                                    <td>+81 90-8100-0786</td>
                                </tr>
                                <tr>
                                    <th scope="row">FAX</th>
                                    <td>0299-56-4954</td>
                                </tr> */}
                                <tr>
                                    <th scope="row">CORPORATE SITE</th>
                                    <td>https://saadmotors.com</td>
                                </tr>
                                <tr>
                                    <th scope="row">E-MAIL ADDRESS</th>
                                    <td>info@saadmotors.com</td>
                                </tr>
                                <tr>
                                    <th scope="row">YEAR ESTABLISHED</th>
                                    <td>2019</td>
                                </tr>
                                <tr>
                                    <th scope="row">BUSINESS DESCRIPTION</th>
                                    <td>Export of Used Cars, Commercial Trucks, Buses, Heavy Equipment and Machinery from Thailand</td>
                                </tr>
                                <tr>
                                    <th scope="row">BANK</th>
                                    <td>KASIKORN BANK PUBLIC COMPANY</td>
                                </tr>
                                <tr>
                                    <th scope="row">LANGUAGE SPOKEN</th>
                                    <td>Englsih , Thai</td>
                                </tr>
                                <tr>
                                    <th scope="row">OFFICE</th>
                                    <td>Head Office in Bangkok Thailand</td>
                                </tr>
                                {/* <tr>
                                    <th scope="row">NUMBER OF EMPLOYEES</th>
                                    <td>150+ EMPLOYEES CURRENTLY WORKING IN BOTH OFFICES</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>

                    <div className="row comrow miss-vis">
                        <div className="col-lg-3 col-md-12">
                            <img src={vision} alt="Vision" className="mimission img-fluid" />
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <p>Our mission is to provide high-quality vehicles at competitive prices while ensuring a smooth, transparent, and hassle-free buying experience for customers around the world.</p>
                        </div>
                        <div className="col-lg-3 col-md-12 mt-3">
                            <img src={mission} alt="Mission" className="mimission img-fluid" />
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <p>With sales offices around the globe and 24/7 customer service centers, we are always here to assist with your purchasing process. We are committed to continuous improvement and strive to exceed customer expectations by providing exceptional service at every step.</p>
                        </div>
                        <div className="col-lg-3 col-md-12 mt-3">
                            <img src={values} alt="Mission" className="mimission img-fluid" />
                        </div>
                        <div className="col-lg-9 col-md-12">
                            <p>We are committed to professionalism, honesty, teamwork, continuous improvement, and customer satisfaction. These values guide every decision we make and help us build lasting relationships with our clients.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default CompanyProfile;